import { useState, useEffect, useCallback } from 'react'

interface IUseElementOnScreenProps {
    target: any
    options?: {
        root?: any
        rootMargin?: string
        threshold?: number
        isUseReactRef?: boolean
        runOnce?: boolean
    }
}

const useElementOnScreen = (props: IUseElementOnScreenProps) => {
    const { target, options } = props
    const [enable, setEnable] = useState<boolean>(true)
    const isUseReactRef =
        props.options && props.options.isUseReactRef !== undefined ? props.options.isUseReactRef : true

    const [isElementOnScreen, setElementOnScreen] = useState<boolean>(false)

    const callbackObserve = useCallback(
        (entities: any) => {
            const [entry] = entities

            setElementOnScreen(entry.isIntersecting)
            if (entry.isIntersecting && options?.runOnce) {
                setEnable(false)
            }
        },
        [options?.runOnce]
    )

    useEffect(() => {
        // on mount
        if (target === undefined || target === null) {
            return
        }
        if (typeof window === 'undefined') {
            return
        }
        if (options === null) {
            return
        }

        if (!enable) {
            return
        }

        let intersectionObserver: IntersectionObserver | null = null
        if (typeof window.IntersectionObserver !== 'undefined') {
            if (isUseReactRef && (target.current === undefined || target.current === null)) {
                return
            }

            intersectionObserver = new IntersectionObserver(callbackObserve, options)
            intersectionObserver.observe(isUseReactRef ? target.current : target)
        }

        return () => {
            // on disMount
            if (target === undefined || target === null) {
                return
            }
            if (isUseReactRef && (target.current === undefined || target.current === null)) {
                return
            }
            if (intersectionObserver !== null) {
                intersectionObserver.unobserve(isUseReactRef ? target.current : target)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [target, enable])

    return [isElementOnScreen]
}

export default useElementOnScreen
export { IUseElementOnScreenProps }
